export default __webpack_public_path__ + "static/media/remover.4fefab30.svg";